import { useEffect, useState } from 'react'
import '../../style.css'
import {
  Balance,
  BalanceDetails,
  Container,
  DateUltimosLancamentos,
  Name,
} from './styles'

import { BsArrowDownShort, BsArrowUpShort } from 'react-icons/bs'

import { format } from 'date-fns'
import brasilLocale from 'date-fns/locale/pt-BR'
import { currencyFormat } from '../../../../utils/currencyFormat'

import { Skeleton } from 'src/components/skeleton'
import { useAuth } from 'src/hooks/auth'
import { dateFormatDaily } from 'src/utils/dateFormat'
import { formatTransactionsTypeLastUpdates } from 'src/utils/formatTransactionsTypeLastUpdates'
import { getFirstName } from 'src/utils/getFirstName'
import { separateTransactions } from 'src/utils/separateTransactions'
import { service } from '../../../../services/ajio'

export const Orders = () => {
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState<any[]>([])
  const { user } = useAuth()

  useEffect(() => {
    service.get(`/transactions?page=1`).then(({ data }) => {
      const sortedFilteredItems = data.transactions.data
        .filter((data: any) => !(data.description === 'P2P AJIOPAY'))
        .sort((a: any, b: any) => {
          const dateA = new Date(a.created_at)
          const dateB = new Date(b.created_at)
          return dateB.getTime() - dateA.getTime()
        })

      const { orderedTransactions } = separateTransactions(sortedFilteredItems)
      const slicedItems = orderedTransactions.slice(0, 6)

      setItems(slicedItems)
      setLoading(false)
    })
  }, [])

  function getType(type: string): string {
    if (type === 'in') {
      return 'Crédito'
    }

    if (type === 'out') {
      return 'Débito'
    }
    return type
  }

  // const handleMouseEnter = () => {
  //   setShowTooltip(true);
  // };

  // const handleMouseLeave = () => {
  //   setShowTooltip(false);
  // };
  return (
    <Container className="w-full h-full flex items-center justify-center py-[2%] px-[3%]">
      <div className="transaction-item-gap  w-full flex flex-col items-center justify-center">
        {!loading && !items.length && (
          <div>
            <div className="text-center">
              <h3 className="mt-2 text-sm font-medium text-gray-900">
                Nenhum lançamento para o mês de{' '}
                <strong>
                  {format(new Date(), 'LLLL', { locale: brasilLocale })}
                </strong>
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                Faça sua primeira transação
              </p>
              <div className="mt-6">
                <button
                  type="button"
                  className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Transferir
                </button>
              </div>
            </div>
          </div>
        )}

        <Skeleton isActive={loading} repeat={2} />

        {!loading &&
          items.map((item) => {
            if (
              item.amount === 0 ||
              item.description === 'TRANSACAO SUSPEITA (NAO CONSILIADA)'
            )
              return null

            return (
              <div
                className="grid grid-cols-[30%,40%,20%] gap-2 sm:gap-4 h-[18%] justify-center items-center w-full border-b border-[#E2E8F0] pb-2"
                key={item.id}
              >
                <div className="flex gap-2 items-center">
                  <div className="flex items-center justify-center border-2 border-[#718EBF] rounded-full aspect-square">
                    {item.direction === 'out' ? (
                      <BsArrowUpShort color="#718EBF" className="last-icon" />
                    ) : (
                      <BsArrowDownShort color="#718EBF" className="last-icon" />
                    )}
                  </div>

                  <Name className="transaction-date-text">
                    {formatTransactionsTypeLastUpdates(item as any, user)}
                  </Name>
                </div>

                <div className="flex items-center justify-around">
                  {item.direction === 'in' ? (
                    <span className="transaction-date-text">
                      {getFirstName(
                        item.type === 'PAGBANK_PAYMENT'
                          ? item.data.payer.name
                          : item.type === 'PAGBANK_PAYMENT_DISCOUNT'
                          ? item.data.payer.name
                          : item?.response?.data?.counterparty?.name ||
                            item?.data?.transfer?.destination_bank_account
                              .beneficiaryName ||
                            item?.data?.data?.payer?.name
                      )}
                    </span>
                  ) : (
                    <span className="transaction-date-text">
                      {getFirstName(
                        item.type === 'PAGBANK_PAYMENT_DISCOUNT'
                          ? item.data.payer.name
                          : item.type === 'PAGBANK_PAYMENT'
                          ? item.data.payer.name
                          : item.payer_bank_name ||
                            item?.data?.transfer?.destination_bank_account
                              ?.beneficiaryName ||
                            ''
                      )}
                    </span>
                  )}
                  <DateUltimosLancamentos className="transaction-text ml-2">
                    {dateFormatDaily(item.created_at)}
                  </DateUltimosLancamentos>
                </div>

                <BalanceDetails className="justify-end">
                  <Balance
                    className="transaction-date-text"
                    credit={item.direction === 'in'}
                  >
                    {item.direction === 'in' ? '+' : '-'}
                    {currencyFormat(Number(item.amount))}
                  </Balance>
                </BalanceDetails>
              </div>
            )
          })}
      </div>
    </Container>
  )
}
